import React, { Component } from 'react'
import { Modal, Row, Col } from 'react-bootstrap';

const backdropStyle = {
    position: 'fixed',
    zIndex: 1040,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#000',
    opacity: 0.5
}

const modalStyle = function() {
    return {
        position: 'fixed',
        width: '80%',
        height: '60%',
        zIndex: 1040,
        top: '30%',
        left: '10%',
        border: '1px solid #e5e5e5',
        backgroundColor: 'dimgray',
        boxShadow: '0 5px 15px rgba(0,0,0,0.5)',
        padding: 20
    }
}

class Landing extends Component {
    constructor(...args) {
        super(...args)
        this.state = {
            showModal: false
        }
    }
    
    close = () => {
        this.setState({
            showModal: false
        })
    }

    open = () => {
        this.setState({
            showModal: true
        })
    }
    
    renderBackdrop(props) {
        return <div {...props} style={backdropStyle} />
    }

    componentDidMount() {
        this.state.showModal === false && this.setState({showModal: true})
    }

    render() {
        return (
            <div className='modal-example'>
                <Modal
                    onHide={this.close}
                    // style={modalStyle()}
                    // aria-labelledby='modal-label'
                    show={this.state.showModal}
                    // renderBackdrop={this.renderBackdrop}
                    >
                    <div>
                        <h4 id='modal-label'>Website Grooming in Progress</h4>
                        <Row>
                            <Col xs={{offset:1, span:1}}>
                            <img src={require('./img/dapperDoggyPaw.png')} alt='paw' className='modal-paw' />
                            </Col>
                            <Col xs={10}>
                                <Row>
                                    <Col>
                                        Please contact us at
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        (208) 731-0213
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        to make an appointment
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <span className='d-none d-md-inline'>We are open </span>Monday to Friday from 8am to 5pm
                                        <br /><br />
                                        314 2nd Ave E<br />Twin Falls, ID 83301
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Landing